import React, { useState, useEffect } from "react";
import FormTable from "../../components/HecoForms/Table/FormTable";
import ToggleTabs from "../../components/ToggleTabs/ToggleTabs";

import Navbar from "../../components/common/Navbar/Navbar";
import GeneralTooltipsModal from "../../components/Modals/FormTooltipsModal/GeneralTooltipsModal";
import DataRequestsButton from "../../components/DataRequests/DataRequestsButton";
import GenerateReport from "../../components/HecoReports/GenerateReport/GenerateReport";
import SaveForLaterModal from "../../components/Modals/SaveForLaterModal/SaveForLaterModal";
import SubmitCompletedModal from "../../components/Modals/SubmitCompletedModal/SubmitCompletedModal";
import CategoriesModal from "../../components/Modals/CategoriesTooltipsModal/CategoriesModal";

import "./InputForm.css";
import RequestRepXButton from "../../components/HecoRepX/RequestRepXButton";
import { useOutletContext } from "react-router-dom";

function InputForm() {
  // Initialise variables
  const [nameEditable, setNameEditable] = useState(false); //boolean that is true if the company name is editable
  const [companyName, setCompanyName] = useState(""); //state to store the company name
  const [selectedFileData, setSelectedFileData] = useState([]); //stored the JSON data from the selected file
  const [toggleState, setToggleState] = useState("");
  const [categoryNames, setCategoryNames] = useState([]); // Define categoryNames
  const [activeTab, setActiveTab] = useState(""); // Define activeTab
  const [currentCategories, setCurrentCategories] = useState([]);
  const [formData, setFormData] = useState([]); //stores the data from the selected File
  const { tabs } = ToggleTabs(toggleState, categoryNames);
  const [unfilledFields, setUnfilledFields] = useState([]);
  const statusTag = localStorage.getItem("snapshotStatus");
  const statusRepXDisableSaveForLater =
    statusTag === "Requested" || statusTag === "Generated";
  const [textareaHeights, setTextareaHeights] = useState({}); //manage height of textareas

  //useEffect to update the inputform with the data from the localstorage
  useEffect(() => {
    //Get the data array from the localstorage
    const documentDataJSON = localStorage.getItem("formattedDataArray");
    //if there is data then parse to a JSON object and save it on selectedFileData
    if (documentDataJSON) {
      const parsedData = JSON.parse(documentDataJSON);
      setSelectedFileData(parsedData);

      //Get the company name from localstorage
      setCompanyName(localStorage.getItem("companyName"));

      //check if company name is true or false (the value from localstorage comes inside quotes)
      let companyNameEditable = localStorage
        .getItem("companyNameEditable")
        .trim();
      if (
        companyNameEditable.toLowerCase() === "true" ||
        companyNameEditable === ""
      ) {
        setNameEditable(true);
      } else {
        setNameEditable(false);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedFileData) {
      // Extract unique categories
      const categories = selectedFileData
        .filter((item) => item["Category (per property)"].trim() !== "")
        .map((item) => item["Category (per property)"].toUpperCase());

      const individualCategories = [...new Set(categories)];

      // Set initial toggle state if not set
      if (!toggleState || !individualCategories.includes(toggleState)) {
        setToggleState(individualCategories[0]);
      }

      setCategoryNames(individualCategories);

      const currentCategoriesSlice = categoryNames.slice(0, 5);
      setCurrentCategories(currentCategoriesSlice);

      // Filter and set form data based on the active category
      const fetchedData = selectedFileData.filter((item) => {
        const category = item["Category (per property)"].toUpperCase();
        return category === toggleState;
      });

      setFormData(fetchedData);
    }
  }, [selectedFileData, toggleState]);

  const toggleTab = (status) => {
    // Prevent going back to the first tab after updating data
    if (activeTab !== status) {
      setToggleState(status);
      setActiveTab(status);
    }
  };

  useEffect(() => {
    // Save the updated formatted data to local storage
    localStorage.setItem("UpdatedDataArray", JSON.stringify(selectedFileData));
  }, [selectedFileData]);

  const handleCompanyNameChange = (e) => {
    const editCompanyName = e.target.value;
    setCompanyName(editCompanyName);

    // update the name in local storage
    localStorage.setItem("companyName", editCompanyName);
  };

  const repoName = localStorage.getItem("repoName");
  const fileName = localStorage.getItem("selectedSnapshot");
  let isRepXFile = fileName.toLowerCase().includes("repx");

  return (
    <>
      <Navbar />

      <div className="grid-container">
        <div className="header">
          <div className="header-title-inputform">
            Input Form
            <div className="form-name">
              <p>
                {repoName} / <span>{fileName}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="search-bar-inputform">
          <div className="tooltip">
            <GeneralTooltipsModal />
          </div>
          <DataRequestsButton />
          <GenerateReport setUnfilledFields={setUnfilledFields} />
          <SaveForLaterModal disabled={statusRepXDisableSaveForLater} />
          {isRepXFile ? (
            <RequestRepXButton setUnfilledFields={setUnfilledFields} />
          ) : (
            <SubmitCompletedModal setUnfilledFields={setUnfilledFields} />
          )}
        </div>
        {/* HecoAnalytics wants to remove the name of the company displayed for now. I am leaving it here in case they want to go back in the future. */}
        {/* {nameEditable === true ? (
          <div className="header-title">
            <input
              type="text"
              className="company-title"
              placeholder="Company name..."
              value={companyName || ""}
              onChange={handleCompanyNameChange}
            />
          </div>
        ) : (
          <div className="header-title">
            <input
              type="text"
              className="company-title"
              placeholder="Company name..."
              value={companyName || ""}
              disabled
            />
          </div>
        )} */}

        <div className="header-title-tooltip">
          <div className="header-title-categories">CATEGORIES</div>
          <div className="categories-tooltip">
            <CategoriesModal />
          </div>
        </div>

        {tabs(toggleTab)}
      </div>

      <FormTable
        formData={formData}
        selectedFileData={selectedFileData}
        setSelectedFileData={setSelectedFileData}
        unfilledFields={unfilledFields}
        activeTab={activeTab}
        textareaHeights={textareaHeights[activeTab] || {}}
        updateTextareaHeight={(index, height) => {
          const newHeights = { ...textareaHeights };
          if (!newHeights[activeTab]) {
            newHeights[activeTab] = {};
          }
          newHeights[activeTab][index] = height;
          setTextareaHeights(newHeights);
        }}
      />
    </>
  );
}

export default InputForm;
